import cloneDeep from 'lodash.clonedeep';
import { Contact } from 'data/contact/contact.types';
import {
  CollectionFunctionGroup,
  CollectionFunctionGroupFormData,
  CollectionFunctionGroupGridData,
} from './collectionFunctionGroup.types';

export function adaptToForm(
  collectionFunctionGroup: CollectionFunctionGroup,
): CollectionFunctionGroupFormData {
  return {
    ...collectionFunctionGroup,
    contact: adaptContactToForm(collectionFunctionGroup.contact),
  };
}

export function adaptToSubmit(
  collectionFunctionGroupForm: CollectionFunctionGroupFormData,
): CollectionFunctionGroup {
  return {
    ...collectionFunctionGroupForm,
    contact: adaptContactToSubmit(collectionFunctionGroupForm.contact),
  };
}

function adaptContactToForm(contact: Contact | undefined): string {
  return contact?.id ?? '';
}

function adaptContactToSubmit(contact: string | undefined): Contact {
  if (!contact) {
    return { id: '', name: '' };
  }

  return { id: contact, name: atob(contact) };
}

export function adaptToGridData(
  collectionFunctionGroups: CollectionFunctionGroup[],
): CollectionFunctionGroupGridData[] {
  const clonedCollectionFunctionGroups = cloneDeep(collectionFunctionGroups);

  const collectionFunctionGroupGridData: CollectionFunctionGroupGridData[] = [];

  clonedCollectionFunctionGroups.forEach((collectionFunctionGroup) => {
    const {
      id,
      name,
      description,
      cfs,
    } = collectionFunctionGroup;

    if (cfs.length === 0) {
      collectionFunctionGroupGridData.push({
        id,
        parentId: id,
        name: `${name} (0)`,
        description,
        collectionFunction: '-',
      });
    }

    cfs.forEach(({ name: collectionFunction }) => {
      if (collectionFunction == null) {
        return;
      }

      collectionFunctionGroupGridData.push({
        id: `${id}.${collectionFunction}`,
        parentId: id,
        name: `${name} (${cfs.length})`,
        description,
        collectionFunction,
      });
    });
  });

  return collectionFunctionGroupGridData;
}
